import React from 'react';
import Joyride from 'react-joyride';
import { useTour } from '../../contexts/TourContext';

const TourWrapper = () => {
   const { isTourOpen, tourSteps, endTour } = useTour();

   return (
      <Joyride
         steps={tourSteps}
         run={isTourOpen}
         continuous
         showProgress
         showSkipButton
         styles={{
            options: {
               primaryColor: '#007bff',
               zIndex: 10000,
            },
         }}
         callback={({ status }) => {
            if (['finished', 'skipped'].includes(status)) {
               endTour();
            }
         }}
      />
   );
};

export default TourWrapper;